import React from 'react';

const MenuIcon24 = ({ className }) => (
  <svg className={className} height="24" width="24">
    <path d="m3 6h18v2h-18zm0 5h18v2h-18zm0 5h18v2h-18z" />
  </svg>
);

export default MenuIcon24;
